import React from "react";

import PageLayout from "../../common/PageLayout";
import ProblemList from "../../problemList/ProblemList";

type Props = {
  embedded?: boolean;
};

const CatalogPage: React.FC<Props> = ({ embedded = false }) => (
  <PageLayout
    withHeader={!embedded}
    withFooter={!embedded}
    hideFooterBackLink
  >
    <ProblemList
      openLinksInNewWindow={embedded}
      isEmbedded={embedded}
    />
  </PageLayout>
);

export default CatalogPage;
